var _toConsumableArray = require("/home/runner/work/leny.github.io/leny.github.io/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/runner/work/leny.github.io/leny.github.io/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var fromEntries = require("lodash.frompairs");

var _require = require("../data"),
    properties = _require.properties;

var _require2 = require("../mixins"),
    mixins = _require2.mixins;

var pwop = function pwop(obj) {
  var entries = [];
  Object.entries(obj).forEach(function (entry) {
    var _entry = _slicedToArray(entry, 2),
        prop = _entry[0],
        value = _entry[1];

    if (mixins[prop]) {
      entries.push.apply(entries, _toConsumableArray(Object.entries(mixins[prop].apply(mixins, _toConsumableArray(Array.isArray(value) ? value : [value])))));
      return;
    }

    if (!Object.values(properties).includes(prop)) {
      if (Object.keys(properties).includes(prop)) {
        prop = properties[prop];
      }
    }

    if (Array.isArray(value)) {
      if (value.reduce(function (b, val) {
        return b || Array.isArray(val);
      }, false)) {
        value = value.map(function (s) {
          return s.join(" ");
        }).join(", ");
      } else {
        value = value.join(" ");
      }
    } else if (value === Object(value)) {
      value = pwop(value);
    }

    entries.push([prop, value]);
  });
  return fromEntries(entries);
};

exports.pwops = pwop;
exports.pwop = pwop;
exports.pwp = pwop;